import { Svg, Path, Rect } from '@react-pdf/renderer';
import { colors } from '@/features/pdf-report/lib/pdf-theme';

export function FileTextIcon() {
    return (
        <Svg width={12} height={12} viewBox="0 0 24 24">
            <Path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" fill="none" stroke={colors.primary} strokeWidth={2} />
            <Path d="M14 2v6h6M16 13H8M16 17H8M10 9H8" fill="none" stroke={colors.primary} strokeWidth={2} />
        </Svg>
    );
}

export function BarChartIcon() {
    return (
        <Svg width={14} height={14} viewBox="0 0 24 24">
            <Rect x="3" y="12" width="4" height="9" rx="1" fill={colors.primary} />
            <Rect x="10" y="7" width="4" height="14" rx="1" fill={colors.primary} />
            <Rect x="17" y="3" width="4" height="18" rx="1" fill={colors.primary} />
        </Svg>
    );
}

export function TrendingUpIcon() {
    return (
        <Svg width={14} height={14} viewBox="0 0 24 24">
            <Path d="M23 6l-9.5 9.5-5-5L1 18" fill="none" stroke={colors.primary} strokeWidth={2} />
            <Path d="M17 6h6v6" fill="none" stroke={colors.primary} strokeWidth={2} />
        </Svg>
    );
}

export function CoinsIcon() {
    return (
        <Svg width={14} height={14} viewBox="0 0 24 24">
            <Path d="M12 2a8 8 0 0 0-8 8c0 4.4 3.6 8 8 8s8-3.6 8-8-3.6-8-8-8z" fill="none" stroke={colors.primary} strokeWidth={2} />
            <Path d="M12 6v4l2 2" fill="none" stroke={colors.primary} strokeWidth={2} />
        </Svg>
    );
}

export function ShieldCheckIcon() {
    return (
        <Svg width={14} height={14} viewBox="0 0 24 24">
            <Path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" fill="none" stroke={colors.primary} strokeWidth={2} />
            <Path d="M9 12l2 2 4-4" fill="none" stroke={colors.primary} strokeWidth={2} />
        </Svg>
    );
}
